module.exports = __webpack_public_path__ + "static/media/Andar_Bahar.b66ed0ca.webp";